import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { SET_DMX_PROFILE_CHANNELS } from './actionTypes';
import { setDmxProfileChannelsSuccessful, setDmxProfileChannelsFailed } from './actions';

import { getDmxAPI } from '../../../api/dmx';

const dmxAPI = getDmxAPI();

function* setProfileChannels({ payload: { profileChannels } }) {
  try {
    const response = yield call(
      dmxAPI.setProfileChannels,
      profileChannels.token,
      profileChannels.id,
      profileChannels.channels,
    );
    if (response.message) {
      yield put(setDmxProfileChannelsSuccessful(response.message));
    } else throw response.error;
  } catch (error) {
    yield put(setDmxProfileChannelsFailed(error));
  }
}

export function* watchSetDmxProfileChannels() {
  yield takeEvery(SET_DMX_PROFILE_CHANNELS, setProfileChannels);
}

function* setDmxProfileChannelsSaga() {
  yield all([fork(watchSetDmxProfileChannels)]);
}

export default setDmxProfileChannelsSaga;
